import { frontendURL } from '../../../helper/URLHelper';
const HomeView = () => import('./HomeProductionView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/home'),
      name: 'home_dashboard',
      component: HomeView,
      meta: {
        permissions: ['administrator', 'agent'],
      },
    },
  ],
};
